import gql from 'graphql-tag'

export const GET_MODAL = gql`
  query {
    modal @client {
      open,
      shouldDismiss,
      loading,
      content {
        type,
        selectType,
        heading,
        body,
        items {
          id,
          name,
          emrMedicationName,
          medicationStructuredSig,
          unstructuredSig
        },
        imageSource,
        zeroStateText,
        data {
          organizationId,
          compositionId,
          sectionId,
          fromConfirm,
          sectionContent,
          isProcessing
        }
      }
    }
  }
`

export const SET_MODAL = gql`
  mutation setModal($content: ModalContent) {
    modal(modal: {
      open: true,
      loading: false,
      content: $content
    }) @client
  }
`

export const CLEAR_MODAL = gql`
  mutation clearModal {
    modal(modal: {
      open: false,
      shouldDismiss: false,
      loading: false
    }) @client
  }
`

export const SET_MODAL_DISMISS = gql`
  mutation setModalDismiss {
    modal(modal: {
      open: true,
      shouldDismiss: true
    }) @client
  }
`

export const SET_MODAL_LOADING = gql`
  mutation setModalLoading {
    modal(modal: {
      open: true,
      loading: true
    }) @client
  }
`
